import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';

import { Environment } from '../../environments/environment';
import { SchdulerOrder } from './scheduler-order';

@Injectable()
export class SchedulerOrderService {
  private ordersUrl = Environment.apiUrl +  'api/orders';  // URL to web api

  constructor(private http: HttpClient) { }

  getOrders(): Promise<SchdulerOrder[]> {
    return this.http.get<SchdulerOrder[]>(this.ordersUrl)
    .toPromise()
    .then(response => {
      console.log(response);
      return response.map(function (order: any) {
        const item: SchdulerOrder = new SchdulerOrder();
        item.id = order.id;
        item.start_date = moment(order.start_date).toDate();
        item.end_date = moment(order.end_date).toDate();
        item.text = order.text;
        item.driver_id = order.driver_id;
        item.color = order.color;
        item.statusCode = order.statusCode;
        item.blockText = order.blockText;
        item.tooltipText = order.tooltipText;
        return item;
  });
 })
    .catch(this.handleError);
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
 /* getOrders(): Promise<SchdulerOrder[]> {
    return Promise.resolve(ORDERS);
  }*/
}



// WEBPACK FOOTER //
// ./src/app/core/scheduler-order.service.ts